// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"BB-z","giftOrPromoSelector":"CB-z","disabled":"DB-z","subTitle":"EB-z","selectShipAddressMessage":"FB-z","changePayment":"GB-z"};